<h1>Dialogs</h1>
<p>
  Esse componente utiliza o MatDialog para abrir um componente modal genérico.
</p>

<div class="container">
  <div class="row mt-5">
    <div class="col-4">
      <h4>Confirm</h4>
      <button class="mz-button small" (click)="openDialog1()">
        Open dialog
      </button>
    </div>
    <div class="col-4">
      <h4>Change buttons</h4>
      <button class="mz-button small" (click)="openDialog2()">
        Open dialog
      </button>
    </div>
    <div class="col-4">
      <h4>Centralized theme</h4>
      <button class="mz-button small" (click)="openDialog3()">
        Open dialog
      </button>
    </div>
  </div>
</div>
